import React, { useCallback, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "primereact/button";
import DefMembershipActions from "../../../Redux/actions/defMembership-actions";
import SegmentsTab from "./SegmentsTab";
import TagsTab from "./TagsTab";
import "../../../Styles/pages/customers.scss";
import "../../../Styles/pages/dashboard.scss";
import "../../../Styles/pages/product.scss";
import "../../../Styles/components/segment.scss";
import "../../../Styles/components/tags.scss";

const TAB_SEGMENTS = 0;
const TAB_TAGS = 1;

const Segments = () => {
    const { t } = useTranslation("common");
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [activeTab, setActiveTab] = useState(TAB_SEGMENTS);

    const defMembership = useSelector((state) => state.defMembership.defMembership);

    const getMembership = useCallback(
        () => dispatch(DefMembershipActions.defMembershipRequest()),
        [dispatch]
    );

    const isAdminOrOwner = defMembership?.role === "OWNER" || defMembership?.role === "ADMIN";
    const businessId = defMembership?.business?.id;

    useEffect(() => {
        if (!defMembership) {
            getMembership();
        }
    }, [defMembership, getMembership]);

    useEffect(() => {
        if (defMembership && !isAdminOrOwner) {
            navigate("/crm/customers", { replace: true });
        }
    }, [defMembership, isAdminOrOwner, navigate]);

    if (!defMembership || !isAdminOrOwner) {
        return null;
    }

    const pageTitle =
        activeTab === TAB_SEGMENTS ? t("segment.page_title") : t("tags.page_title");
    const pageDescription =
        activeTab === TAB_SEGMENTS
            ? t("segment.page_description")
            : t("tags.page_description");

    return (
        <div className="customerContent segments-screen segments-tags-screen">
            <div className="segments-page-intro">
                <h2 className="segments-page-title">{pageTitle}</h2>
                <p className="segments-page-description">{pageDescription}</p>
            </div>

            <div className="segments-tags-tabs plans-tabs-btn">
                <Button
                    type="button"
                    className={`p-button-text plans-table-btn segments-tab-toggle ${
                        activeTab === TAB_SEGMENTS
                            ? "p-button-raised p-button-info active active-tabs"
                            : "p-button-plain not-active not-active-tabs"
                    }`}
                    label={t("segment.label")}
                    onClick={() => setActiveTab(TAB_SEGMENTS)}
                />
                <Button
                    type="button"
                    className={`p-button-text plans-table-btn tags-tab-toggle ${
                        activeTab === TAB_TAGS
                            ? "p-button-raised p-button-info active active-tabs"
                            : "p-button-plain not-active not-active-tabs"
                    }`}
                    label={t("common.tags")}
                    onClick={() => setActiveTab(TAB_TAGS)}
                />
            </div>

            {activeTab === TAB_SEGMENTS && <SegmentsTab businessId={businessId} />}
            {activeTab === TAB_TAGS && (
                <TagsTab businessId={businessId} defMembership={defMembership} />
            )}
        </div>
    );
};

export default Segments;
